export default {
    url: '/requirements',
    template: '<user-competence-requirements classifiers="vm.classifiers"/>',
    resolve: {
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise
    },
    controller (classifiers) {
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/requirements/index.js